import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Separator } from '../components/ui/separator';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { mockProducts } from '../mockData';
import { ShoppingCart } from 'lucide-react';

const CATEGORY_OPTIONS = [
  { value: 'vitamin', label: 'Vitamin' },
  { value: 'sleep', label: 'Gối / Ngủ' },
  { value: 'support', label: 'Đai đỡ' },
  { value: 'skincare', label: 'Chăm sóc da' },
  { value: 'milk', label: 'Sữa cho bé' },
];

function Shopping() {
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState(null);
  const [pregMonth, setPregMonth] = useState(null);
  const [babyMonth, setBabyMonth] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios
      .get('http://localhost:9999/products')
      .then((res) => {
        setProducts(res.data);
        setFiltered(res.data);
      })
      .catch(() => {
        setProducts(mockProducts);
        setFiltered(mockProducts);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = [...products];

    if (search) {
      result = result.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (category) {
      result = result.filter((p) => p.category === category);
    }
    if (pregMonth !== null && pregMonth !== undefined) {
      result = result.filter(
        (p) =>
          p.forPregMonthFrom != null &&
          pregMonth >= p.forPregMonthFrom &&
          pregMonth <= p.forPregMonthTo
      );
    }
    if (babyMonth !== null && babyMonth !== undefined) {
      result = result.filter(
        (p) =>
          p.forBabyMonthFrom != null &&
          babyMonth >= p.forBabyMonthFrom &&
          babyMonth <= p.forBabyMonthTo
      );
    }

    setFiltered(result);
  }, [search, category, pregMonth, babyMonth, products]);

  const handleAddToCart = (p) => {
    // Có thể tích hợp giỏ hàng sau
    console.log('Thêm vào giỏ:', p.name);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50/50 via-white to-pink-50/50">
      <Navbar />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h2 className="text-3xl font-bold text-center mb-2 mt-6">
          <span className="bg-gradient-to-r from-pink-500 to-pink-700 bg-clip-text text-transparent">
            Mua sắm cho mẹ & bé
          </span>
        </h2>
        <p className="text-gray-600 text-center mb-8">
          Sản phẩm phù hợp theo giai đoạn thai kỳ và độ tuổi bé
        </p>

        {/* Filter bar */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <Select value={category ?? ''} onValueChange={(v) => setCategory(v || null)}>
            <SelectTrigger className="w-full border-pink-200 focus:ring-pink-500">
              <SelectValue placeholder="Loại sản phẩm" />
            </SelectTrigger>
            <SelectContent>
              {CATEGORY_OPTIONS.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select
            value={pregMonth != null ? String(pregMonth) : ''}
            onValueChange={(v) => setPregMonth(v ? Number(v) : null)}
          >
            <SelectTrigger className="w-full border-pink-200 focus:ring-pink-500">
              <SelectValue placeholder="Tháng thai kỳ" />
            </SelectTrigger>
            <SelectContent>
              {[...Array(9)].map((_, i) => (
                <SelectItem key={i + 1} value={String(i + 1)}>
                  Tháng {i + 1}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select
            value={babyMonth != null ? String(babyMonth) : ''}
            onValueChange={(v) => setBabyMonth(v ? Number(v) : null)}
          >
            <SelectTrigger className="w-full border-pink-200 focus:ring-pink-500">
              <SelectValue placeholder="Tháng của bé" />
            </SelectTrigger>
            <SelectContent>
              {[...Array(25)].map((_, i) => (
                <SelectItem key={i} value={String(i)}>
                  {i} tháng
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Input
            placeholder="Tìm sản phẩm..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border-pink-200 focus-visible:ring-pink-500"
          />
        </div>

        <Separator className="mb-8 bg-pink-100" />

        {/* Product list */}
        {loading ? (
          <div className="text-center py-12 text-gray-500">Đang tải...</div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            Không tìm thấy sản phẩm phù hợp. Thử đổi bộ lọc hoặc từ khóa.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((p) => (
              <Card
                key={p.id}
                className="overflow-hidden border-pink-100 hover:shadow-lg hover:border-pink-200 transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <CardContent className="p-4">
                  <h3 className="font-semibold text-gray-800 line-clamp-2 mb-2 min-h-[2.5rem]">
                    {p.name}
                  </h3>
                  <p className="text-pink-600 font-bold text-lg mb-3">
                    {Number(p.price).toLocaleString('vi-VN')} đ
                  </p>
                  <Button
                    type="button"
                    className="w-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white"
                    onClick={() => handleAddToCart(p)}
                  >
                    <ShoppingCart className="w-4 h-4 mr-2" />
                    Thêm vào giỏ
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Shopping;
